// @flow

import React, { type Node } from 'react';

import { type LookAndFeelRootPropsConfirmedPayment } from '@tectonics/look-and-feel';
import { IncomingPaymentProvider, AutoRedirectComponent } from '@tectonics/prs/incoming-payment';
import { PaymentSpecProvider } from '@tectonics/prs/payment-spec';
import { UserInputValuesProvider } from '@tectonics/prs/user-input-values';

import { GlobalStyle } from '../../commons/global-style';
import { LayoutBase, LayoutSideLeft, LayoutSideRight, MainPanel, MainPanelContent } from '../../template';
import { SideDisplay } from '../../organisms/side-display';
import { PageContent } from './page-content';

export function PageConfirmedPayment({ spec, incomingPayment, userInputValues, onUserInput }: LookAndFeelRootPropsConfirmedPayment): Node {
  return (
    <PaymentSpecProvider spec={spec}>
      <IncomingPaymentProvider incomingPayment={incomingPayment}>
        <UserInputValuesProvider values={userInputValues} setValue={onUserInput}>

          <AutoRedirectComponent />

          <GlobalStyle />

          <LayoutBase data-test-id="page-confirmed-payment">
            <LayoutSideLeft>
              <MainPanel>
                <MainPanelContent>
                  <PageContent />
                </MainPanelContent>
              </MainPanel>
            </LayoutSideLeft>

            <LayoutSideRight>
              <SideDisplay />
            </LayoutSideRight>
          </LayoutBase>

        </UserInputValuesProvider>
      </IncomingPaymentProvider>
    </PaymentSpecProvider>
  );
}
